<template>
    <div>
        <el-radio-group v-model="radio1" class="tab">
            <el-radio-button label="上报监控数据"></el-radio-button>
            <el-radio-button label="上报状态数据"></el-radio-button>
        </el-radio-group>
          <el-form :model="rule" :rules="rules" ref="forms" class="flexform" label-width="140px" v-show="radio1=='上报监控数据'">
            <el-form-item label="设备号" prop="devId">
                <el-input placeholder="请输入设备号" v-model="rule.devId" clearable></el-input>
            </el-form-item>
            <el-form-item label="">
            </el-form-item>
            <el-form-item label="采集时间" prop="time">
                <el-date-picker
                    v-model="rule.time"
                    type="datetime"
                    value-format="yyyyMMddHHmmss"
                    format="yyyy/MM/dd HH:mm:ss"
                    placeholder="选择采集时间">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="终端采集状态" prop="collStatus">
                <el-switch
                    v-model="rule.collStatus"
                    active-value="1"
                    inactive-value="0"
                    active-color="#13ce66"
                    inactive-color="#eeeeee">
                </el-switch>
            </el-form-item>
            <el-form-item label="温度" prop="temp">
                <el-input type="number" placeholder="请输入温度" v-model="rule.temp" clearable></el-input>
            </el-form-item>
            <el-form-item label="颠簸" prop="bumpy">
                <el-switch
                    v-model="rule.bumpy"
                    active-value="1"
                    inactive-value="0"
                    active-color="#13ce66"
                    inactive-color="#eeeeee">
                </el-switch>
            </el-form-item>
            <el-form-item label="湿度" prop="hum">
                <el-input type="number" placeholder="请输入湿度" v-model="rule.hum" clearable></el-input>
            </el-form-item>
            <el-form-item label="移动" prop="move">
                <el-switch
                    v-model="rule.move"
                    active-value="1"
                    inactive-value="0"
                    active-color="#13ce66"
                    inactive-color="#eeeeee">
                </el-switch>
            </el-form-item>
            <el-form-item label="正面光敏" prop="positivPptoto">
                <el-input type="number" placeholder="请输入正面光敏" v-model="rule.positivPptoto" clearable></el-input>
            </el-form-item>
            <el-form-item label="撞击" prop="impact">
                <el-switch
                    v-model="rule.impact"
                    active-value="1"
                    inactive-value="0"
                    active-color="#13ce66"
                    inactive-color="#eeeeee">
                </el-switch>
            </el-form-item>
            <el-form-item label="反面光敏" prop="reversePptoto">
                <el-input type="number" placeholder="请输入反面光敏" v-model="rule.reversePptoto" clearable></el-input>
            </el-form-item>
            <el-form-item label="翻倒" prop="ownerTurn">
                <el-switch
                    v-model="rule.ownerTurn"
                    active-value="1"
                    inactive-value="0"
                    active-color="#13ce66"
                    inactive-color="#eeeeee">
                </el-switch>
            </el-form-item>
            <el-form-item label="速度" prop="speed">
                <el-input type="number" placeholder="请输入速度" v-model="rule.speed" clearable></el-input>
            </el-form-item>
            <el-form-item label="静止" prop="staticVal">
                <el-switch
                    v-model="rule.staticVal"
                    active-value="1"
                    inactive-value="0"
                    active-color="#13ce66"
                    inactive-color="#eeeeee">
                </el-switch>
            </el-form-item>
            <el-form-item label="海拔" prop="elev">
                <el-input type="number" placeholder="请输入海拔" v-model="rule.elev" clearable></el-input>
            </el-form-item>
            <el-form-item label="跌撞" prop="bump">
                <el-switch
                    v-model="rule.bump"
                    active-value="1"
                    inactive-value="0"
                    active-color="#13ce66"
                    inactive-color="#eeeeee">
                </el-switch>
            </el-form-item>
            <el-form-item label="卫星颗数" prop="sateNum">
                <el-input type="number" placeholder="请输入卫星颗数" v-model="rule.sateNum" clearable></el-input>
            </el-form-item>
            <el-form-item label="自由落体" prop="freeFall">
                <el-switch
                    v-model="rule.freeFall"
                    active-value="1"
                    inactive-value="0"
                    active-color="#13ce66"
                    inactive-color="#eeeeee">
                </el-switch>
            </el-form-item>
            <el-form-item label="定位状态" prop="locaStatus">
                <el-select v-model="rule.locaStatus">
                    <el-option value="0" label="无GPS"></el-option>
                    <el-option value="1" label="有GPS，无定位"></el-option>
                    <el-option value="2" label="2D定位"></el-option>
                    <el-option value="3" label="3D定位"></el-option>
                    <el-option value="4" label="优于3D定位"></el-option>
                    <el-option value="5" label="RTK浮点解状态"></el-option>
                    <el-option value="6" label="RTK固定解状态"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="开机告警" prop="powerOn">
                <el-switch
                    v-model="rule.powerOn"
                    active-value="1"
                    inactive-value="0"
                    active-color="#13ce66"
                    inactive-color="#eeeeee">
                </el-switch>
            </el-form-item>
            <el-form-item label="电量" prop="elec">
                <el-input type="number" placeholder="请输入电量" v-model="rule.elec" clearable></el-input>
            </el-form-item>
            <el-form-item label="关机告警" prop="powerOff">
                <el-switch
                    v-model="rule.powerOff"
                    active-value="1"
                    inactive-value="0"
                    active-color="#13ce66"
                    inactive-color="#eeeeee">
                </el-switch>
            </el-form-item>
            <el-form-item label="经度" prop="longitude">
                <el-input type="number" placeholder="请输入经度" v-model="rule.longitude" clearable></el-input>
            </el-form-item>
            <el-form-item label="历史数据补报" prop="his">
                <el-switch
                    v-model="rule.his"
                    active-value="1"
                    inactive-value="0"
                    active-color="#13ce66"
                    inactive-color="#eeeeee">
                </el-switch>
            </el-form-item>
            <el-form-item label="纬度" prop="latitude">
                <el-input type="number" placeholder="请输入纬度" v-model="rule.latitude" clearable></el-input>
            </el-form-item>
            <el-form-item label="低电状态" prop="lowElec">
                <el-switch
                    v-model="rule.lowElec"
                    active-value="1"
                    inactive-value="0"
                    active-color="#13ce66"
                    inactive-color="#eeeeee">
                </el-switch>
            </el-form-item>
            <el-form-item label="安装方向" prop="direction">
                <el-select v-model="rule.direction">
                    <el-option value="1" label="水平安装"></el-option>
                    <el-option value="2" label="垂直安装"></el-option>
                    <el-option value="3" label="横向安装"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="飞行状态" prop="flight">
                <el-switch
                    v-model="rule.flight"
                    active-value="1"
                    inactive-value="0"
                    active-color="#13ce66"
                    inactive-color="#eeeeee">
                </el-switch>
            </el-form-item>
            <el-form-item label="震动" prop="vibration">
                <el-input type="number" placeholder="请输入震动" v-model="rule.vibration" clearable></el-input>
            </el-form-item>
            <el-form-item label="立即上报状态" prop="report">
                <el-switch
                    v-model="rule.report"
                    active-value="1"
                    inactive-value="0"
                    active-color="#13ce66"
                    inactive-color="#eeeeee">
                </el-switch>
            </el-form-item>
            <el-form-item label="X轴震动" prop="vibrationX">
                <el-input type="number" placeholder="请输入X轴震动" v-model="rule.vibrationX" clearable></el-input>
            </el-form-item>
            <el-form-item label="进入低电事件" prop="inLowElecEvent">
                <el-switch
                    v-model="rule.inLowElecEvent"
                    active-value="1"
                    inactive-value="0"
                    active-color="#13ce66"
                    inactive-color="#eeeeee">
                </el-switch>
            </el-form-item>
            <el-form-item label="Y轴震动" prop="vibrationY">
                <el-input type="number" placeholder="请输入Y轴震动" v-model="rule.vibrationY" clearable></el-input>
            </el-form-item>
            <el-form-item label="退出低电事件" prop="exitLowElecEvent">
                <el-switch
                    v-model="rule.exitLowElecEvent"
                    active-value="1"
                    inactive-value="0"
                    active-color="#13ce66"
                    inactive-color="#eeeeee">
                </el-switch>
            </el-form-item>
            <el-form-item label="Z轴震动" prop="vibrationZ">
                <el-input type="number" placeholder="请输入Z轴震动" v-model="rule.vibrationZ" clearable></el-input>
            </el-form-item>
            <el-form-item label="进入飞行模式事件" prop="inFlightEvent">
                <el-switch
                    v-model="rule.inFlightEvent"
                    active-value="1"
                    inactive-value="0"
                    active-color="#13ce66"
                    inactive-color="#eeeeee">
                </el-switch>
            </el-form-item>
            <el-form-item label="X轴倾斜" prop="tiltX">
                <el-input type="number" placeholder="请输入X轴倾斜" v-model="rule.tiltX" clearable></el-input>
            </el-form-item>
            <el-form-item label="退出飞行模式事件" prop="exitFlightEvent">
                <el-switch
                    v-model="rule.exitFlightEvent"
                    active-value="1"
                    inactive-value="0"
                    active-color="#13ce66"
                    inactive-color="#eeeeee">
                </el-switch>
            </el-form-item>
            <el-form-item label="Y轴倾斜" prop="tiltY">
                <el-input type="number" placeholder="请输入Y轴倾斜" v-model="rule.tiltY" clearable></el-input>
            </el-form-item>
            <el-form-item label="行程状态" prop="trip">
                <el-switch
                    v-model="rule.trip"
                    active-value="1"
                    inactive-value="0"
                    active-color="#13ce66"
                    inactive-color="#eeeeee">
                </el-switch>
            </el-form-item>
            <el-form-item label="Z轴倾斜" prop="tiltZ">
                <el-input type="number" placeholder="请输入Z轴倾斜" v-model="rule.tiltZ" clearable></el-input>
            </el-form-item>
            <el-form-item label=""></el-form-item>
            <el-form-item label="自由落体高度" prop="fallHeight">
                <el-input type="number" placeholder="请输入自由落体高度" v-model="rule.fallHeight" clearable></el-input>
            </el-form-item>
            <el-form-item label=""></el-form-item>
            <el-form-item>
                <el-button type="primary" @click="submit">提交</el-button>
                <el-button @click="reset">重置</el-button>
            </el-form-item>
        </el-form>

        <el-form :model="rule2" :rules="statusRules" ref="forms2" class="flexform" label-width="140px" v-show="radio1=='上报状态数据'">
            <el-form-item label="设备号" prop="devId">
                <el-input placeholder="请输入设备号" v-model="rule2.devId" clearable></el-input>
            </el-form-item>
            <el-form-item label="">
            </el-form-item>
            <el-form-item label="采集时间" prop="time">
                <el-date-picker
                    v-model="rule2.time"
                    type="datetime"
                    value-format="yyyyMMddHHmmss"
                    format="yyyy/MM/dd HH:mm:ss"
                    placeholder="选择采集时间">
                </el-date-picker>
            </el-form-item>
            <el-form-item label=""></el-form-item>
            <el-form-item label="经度" prop="longitude">
                <el-input type="number" placeholder="请输入经度" v-model="rule2.longitude" clearable></el-input>
            </el-form-item>
            <el-form-item label="开机警告" prop="powerOn">
                <el-switch
                    v-model="rule2.powerOn"
                    active-value="1"
                    inactive-value="0"
                    active-color="#13ce66"
                    inactive-color="#eeeeee">
                </el-switch>
            </el-form-item>
            <el-form-item label="纬度" prop="latitude">
                <el-input type="number" placeholder="请输入纬度" v-model="rule2.latitude" clearable></el-input>
            </el-form-item>
            <el-form-item label="关机警告" prop="powerOff">
                <el-switch
                    v-model="rule2.powerOff"
                    active-value="1"
                    inactive-value="0"
                    active-color="#13ce66"
                    inactive-color="#eeeeee">
                </el-switch>
            </el-form-item>
            <el-form-item label="速度" prop="speed">
                <el-input type="number" placeholder="请输入速度" v-model="rule2.speed" clearable></el-input>
            </el-form-item>
            <el-form-item label="行程状态" prop="trip">
                <el-switch
                    v-model="rule2.trip"
                    active-value="1"
                    inactive-value="0"
                    active-color="#13ce66"
                    inactive-color="#eeeeee">
                </el-switch>
            </el-form-item>
            <el-form-item label="海拔" prop="elev">
                <el-input type="number" placeholder="请输入海拔" v-model="rule2.elev" clearable></el-input>
            </el-form-item>
            <el-form-item label="历史数据补报" prop="his">
                <el-switch
                    v-model="rule2.his"
                    active-value="1"
                    inactive-value="0"
                    active-color="#13ce66"
                    inactive-color="#eeeeee">
                </el-switch>
            </el-form-item>
            <el-form-item label="卫星颗数" prop="sateNum">
                <el-input type="number" placeholder="请输入卫星颗数" v-model="rule2.sateNum" clearable></el-input>
            </el-form-item>
            <el-form-item label="终端采集状态" prop="collStatus">
                <el-switch
                    v-model="rule2.collStatus"
                    active-value="1"
                    inactive-value="0"
                    active-color="#13ce66"
                    inactive-color="#eeeeee">
                </el-switch>
            </el-form-item>
            <el-form-item label="定位状态" prop="locaStatus">
                <el-select v-model="rule2.locaStatus">
                    <el-option value="0" label="无GPS"></el-option>
                    <el-option value="1" label="有GPS，无定位"></el-option>
                    <el-option value="2" label="2D定位"></el-option>
                    <el-option value="3" label="3D定位"></el-option>
                    <el-option value="4" label="优于3D定位"></el-option>
                    <el-option value="5" label="RTK浮点解状态"></el-option>
                    <el-option value="6" label="RTK固定解状态"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="低电状态" prop="lowElec">
                <el-switch
                    v-model="rule2.lowElec"
                    active-value="1"
                    inactive-value="0"
                    active-color="#13ce66"
                    inactive-color="#eeeeee">
                </el-switch>
            </el-form-item>
            <el-form-item label="电量" prop="elec">
                <el-input type="number" placeholder="请输入电量" v-model="rule2.elec" clearable></el-input>
            </el-form-item>
            <el-form-item label="飞行状态" prop="flight">
                <el-switch
                    v-model="rule2.flight"
                    active-value="1"
                    inactive-value="0"
                    active-color="#13ce66"
                    inactive-color="#eeeeee">
                </el-switch>
            </el-form-item>
            <el-form-item label="信号" prop="rssi">
                <el-input type="number" placeholder="请输入信号" v-model="rule2.rssi" clearable></el-input>
            </el-form-item>
            <el-form-item label="立即上报状态" prop="report">
                <el-switch
                    v-model="rule2.report"
                    active-value="1"
                    inactive-value="0"
                    active-color="#13ce66"
                    inactive-color="#eeeeee">
                </el-switch>
            </el-form-item>
            <el-form-item label="GPS来源" prop="gpsSource">
                <el-select v-model="rule2.gpsSource">
                    <el-option value="0" label="无服务"></el-option>
                    <el-option value="1" label="GSM"></el-option>
                    <el-option value="2" label="GPRS"></el-option>
                    <el-option value="3" label="EGPRS"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="进入低电事件" prop="inLowElecEvent">
                <el-switch
                    v-model="rule2.inLowElecEvent"
                    active-value="1"
                    inactive-value="0"
                    active-color="#13ce66"
                    inactive-color="#eeeeee">
                </el-switch>
            </el-form-item>
            <el-form-item label="基站个数" prop="cellNum">
                <el-input type="number" placeholder="请输入基站个数" v-model="rule2.cellNum" clearable></el-input>
            </el-form-item>
            <el-form-item label="退出低电事件" prop="exitLowElecEvent">
                <el-switch
                    v-model="rule2.exitLowElecEvent"
                    active-value="1"
                    inactive-value="0"
                    active-color="#13ce66"
                    inactive-color="#eeeeee">
                </el-switch>
            </el-form-item>
            <el-form-item label="网络制式" prop="network">
                <el-input type="number" placeholder="请输入网络制式" v-model="rule2.network" clearable></el-input>
            </el-form-item>
            <el-form-item label="进入飞行模式事件" prop="inFlightEvent">
                <el-switch
                    v-model="rule2.inFlightEvent"
                    active-value="1"
                    inactive-value="0"
                    active-color="#13ce66"
                    inactive-color="#eeeeee">
                </el-switch>
            </el-form-item>
            <el-form-item label="工作波段" prop="band">
                <el-input placeholder="请输入工作波段" v-model="rule2.band" clearable></el-input>
            </el-form-item>
            <el-form-item label="退出飞行模式事件" prop="exitFlightEvent">
                <el-switch
                    v-model="rule2.exitFlightEvent"
                    active-value="1"
                    inactive-value="0"
                    active-color="#13ce66"
                    inactive-color="#eeeeee">
                </el-switch>
            </el-form-item>
            <el-form-item label="基站1" class="noflex">
                <label>ID</label>
                <el-input type="number" placeholder="请输入LAC" v-model="rule2.cells[0].cellId"></el-input>
                <label>LAC</label>
                <el-input type="number" placeholder="请输入LAC" v-model="rule2.cells[0].lac"></el-input>
                <label>MNC</label>
                <el-input type="number" placeholder="请输入MNC" v-model="rule2.cells[0].mnc"></el-input>
                <label>MCC</label>
                <el-input type="number" placeholder="请输入MCC" v-model="rule2.cells[0].mcc"></el-input>
                <label>RSSI</label>
                <el-input type="number" placeholder="请输入RSSI" v-model="rule2.cells[0].rssi"></el-input>
            </el-form-item>
            <el-form-item label="基站2" prop="temp" class="noflex">
                <label>ID</label>
                <el-input type="number" placeholder="请输入LAC" v-model="rule2.cells[1].cellId"></el-input>
                <label>LAC</label>
                <el-input type="number" placeholder="请输入LAC" v-model="rule2.cells[1].lac"></el-input>
                <label>MNC</label>
                <el-input type="number" placeholder="请输入MNC" v-model="rule2.cells[1].mnc"></el-input>
                <label>MCC</label>
                <el-input type="number" placeholder="请输入MCC" v-model="rule2.cells[1].mcc"></el-input>
                <label>RSSI</label>
                <el-input type="number" placeholder="请输入RSSI" v-model="rule2.cells[1].rssi"></el-input>
            </el-form-item>
            <el-form-item label="基站3" prop="temp" class="noflex">
                <label>ID</label>
                <el-input type="number" placeholder="请输入LAC" v-model="rule2.cells[2].cellId"></el-input>
                <label>LAC</label>
                <el-input type="number" placeholder="请输入LAC" v-model="rule2.cells[2].lac"></el-input>
                <label>MNC</label>
                <el-input type="number" placeholder="请输入MNC" v-model="rule2.cells[2].mnc"></el-input>
                <label>MCC</label>
                <el-input type="number" placeholder="请输入MCC" v-model="rule2.cells[2].mcc"></el-input>
                <label>RSSI</label>
                <el-input type="number" placeholder="请输入RSSI" v-model="rule2.cells[2].rssi"></el-input>
            </el-form-item>
            <el-form-item label="基站4" prop="temp" class="noflex">
                <label>ID</label>
                <el-input type="number" placeholder="请输入LAC" v-model="rule2.cells[3].cellId"></el-input>
                <label>LAC</label>
                <el-input type="number" placeholder="请输入LAC" v-model="rule2.cells[3].lac"></el-input>
                <label>MNC</label>
                <el-input type="number" placeholder="请输入MNC" v-model="rule2.cells[3].mnc"></el-input>
                <label>MCC</label>
                <el-input type="number" placeholder="请输入MCC" v-model="rule2.cells[3].mcc"></el-input>
                <label>RSSI</label>
                <el-input type="number" placeholder="请输入RSSI" v-model="rule2.cells[3].rssi"></el-input>
            </el-form-item>
            <el-form-item label="基站5" prop="temp" class="noflex">
                <label>ID</label>
                <el-input type="number" placeholder="请输入LAC" v-model="rule2.cells[4].cellId"></el-input>
                <label>LAC</label>
                <el-input type="number" placeholder="请输入LAC" v-model="rule2.cells[4].lac"></el-input>
                <label>MNC</label>
                <el-input type="number" placeholder="请输入MNC" v-model="rule2.cells[4].mnc"></el-input>
                <label>MCC</label>
                <el-input type="number" placeholder="请输入MCC" v-model="rule2.cells[4].mcc"></el-input>
                <label>RSSI</label>
                <el-input type="number" placeholder="请输入RSSI" v-model="rule2.cells[4].rssi"></el-input>
            </el-form-item>
            <el-form-item label="基站6" prop="temp" class="noflex">
                <label>ID</label>
                <el-input type="number" placeholder="请输入LAC" v-model="rule2.cells[5].cellId"></el-input>
                <label>LAC</label>
                <el-input type="number" placeholder="请输入LAC" v-model="rule2.cells[5].lac"></el-input>
                <label>MNC</label>
                <el-input type="number" placeholder="请输入MNC" v-model="rule2.cells[5].mnc"></el-input>
                <label>MCC</label>
                <el-input type="number" placeholder="请输入MCC" v-model="rule2.cells[5].mcc"></el-input>
                <label>RSSI</label>
                <el-input type="number" placeholder="请输入RSSI" v-model="rule2.cells[5].rssi"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="submit2">提交</el-button>
                <el-button @click="reset2">重置</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                name: 'edit',
                radio1:'上报监控数据',
                rule: {
                    bump: 0,
                    bumpy: 0,
                    collStatus: 0,
                    devId: '',
                    direction: '1',
                    elec: null,
                    elev: null,
                    exitFlightEvent: 0,
                    exitLowElecEvent: 0,
                    fallHeight: null,
                    flight:0,
                    freeFall: 0,
                    his:0,
                    hum:null,
                    impact:0,
                    inFlightEvent:0,
                    inLowElecEvent:0,
                    latitude: null,
                    locaStatus: '0',
                    longitude: null,
                    lowElec:0,
                    move:0,
                    ownerTurn:0,
                    positivPptoto:null,
                    powerOff:0,
                    powerOn:0,
                    report:0,
                    reversePptoto:null,
                    sateNum:null,
                    speed:null,
                    staticVal:0,
                    temp:null,
                    tiltX:null,
                    tiltY:null,
                    tiltZ:null,
                    time: null,
                    trip:0,
                    vibration:null,
                    vibrationX: null,
                    vibrationY: null,
                    vibrationZ: null,
                },
                rules: {
                    devId: { required: true, message: '请输入设备号' },
                    elec: { required: true, message: '请输入电量' },
                    elev: { required: true, message: '请输入海拔' },
                    fallHeight: { required: true, message: '请输入自由落体高度' },
                    sateNum: { required: true, message: '请输入卫星颗数' },
                    speed: { required: true, message: '请输入速度' },
                    longitude: { required: true, message: '请输入经度' },
                    latitude: { required: true, message: '请输入纬度' },
                    temp: { required: true, message: '请输入温度' },
                    hum: { required: true, message: '请输入湿度' },
                    positivPptoto: { required: true, message: '请输入正面光敏' },
                    reversePptoto: { required: true, message: '请输入反面光敏' },
                    tiltX: { required: true, message: '请输入X轴倾斜' },
                    tiltY: { required: true, message: '请输入Y轴倾斜' },
                    tiltZ: { required: true, message: '请输入Z轴倾斜' },
                    vibration: { required: true, message: '请输入震动' },
                    vibrationX: { required: true, message: '请输入X轴震动' },
                    vibrationY: { required: true, message: '请输入Y轴震动' },
                    vibrationZ: { required: true, message: '请输入Z轴震动' },
                    time: { required: true, message: '请选择采集时间' },
                },
                rule2:{
                    band:'',
                    cellNum:null,
                    collStatus:0,
                    devId:'',
                    elec:null,
                    elev:null,
                    exitFlightEvent:0,
                    exitLowElecEvent:0,
                    flight:0,
                    gpsSource:'0',
                    his:0,
                    inFlightEvent:0,
                    inLowElecEvent:0,
                    latitude:null,
                    locaStatus:'0',
                    longitude:null,
                    lowElec: 0,
                    network:'',
                    powerOff:0,
                    powerOn:0,
                    report:0,
                    rssi:'',
                    sateNum:null,
                    speed:null,
                    time:'',
                    trip:0,
                    cells:[
                        {cellId:null,lac:null,mcc:null,mnc:null,rssi:null},
                        {cellId:null,lac:null,mcc:null,mnc:null,rssi:null},
                        {cellId:null,lac:null,mcc:null,mnc:null,rssi:null},
                        {cellId:null,lac:null,mcc:null,mnc:null,rssi:null},
                        {cellId:null,lac:null,mcc:null,mnc:null,rssi:null},
                        {cellId:null,lac:null,mcc:null,mnc:null,rssi:null},
                    ]
                },
                statusRules:{
                    band: { required: true, message: '请输入工作波段' },
                    cellNum: { required: true, message: '请输入基站个数' },
                    devId: { required: true, message: '请输入设备号' },
                    elec: { required: true, message: '请输入电量' },
                    elev: { required: true, message: '请输入海拔' },
                    latitude: { required: true, message: '请输入纬度' },
                    longitude: { required: true, message: '请输入经度' },
                    network: { required: true, message: '请输入网络制式' },
                    rssi: { required: true, message: '请输入信号' },
                    sateNum: { required: true, message: '请输入卫星颗数' },
                    speed: { required: true, message: '请输入速度' },
                    time: { required: true, message: '请选择采集时间' },
                }
            }
        },
        methods: {
            submit() {
                this.$refs['forms'].validate(valid => {
                    if(valid) {
                        this.rule.direction = Number(this.rule.direction)
                        this.$http.post('/manage/dev/report/monitorData',this.rule).then(rs => {
                            if(rs.data.code == 0) {
                                this.$message({
                                    message: '操作成功',
                                    type: 'success'
                                });
                                setTimeout(() => {
                                    location.href = '/test/index';
                                }, 3000);
                            }else {
                                this.$message({
                                    message: rs.data.message,
                                    type: 'error'
                                });
                            }
                        })
                    }
                });
            },
            reset() {
                this.$refs['forms'].resetFields();
            },
            submit2() {
                this.$refs['forms2'].validate(valid => {
                    if(valid) {
                        let ok = true;
                        for(let i=0;i<this.rule2.cells.length;i++) {
                            for(let y in this.rule2.cells[i]) {
                                if(this.rule2.cells[i][y] == '' || this.rule2.cells[i][y]==null) {
                                    this.$message({
                                        message: `请输入基站${i+1} ${y}`,
                                        type: 'error'
                                    });
                                    ok = false;
                                    return false;
                                }
                            }
                        }
                        if(ok) {
                            this.$http.post('/manage/dev/report/locationData',this.rule2).then(rs => {
                                if(rs.data.code == 0) {
                                    this.$message({
                                        message: '操作成功',
                                        type: 'success'
                                    });
                                    setTimeout(() => {
                                        location.href = '/test/index';
                                    }, 3000);
                                }else {
                                    this.$message({
                                        message: rs.data.message,
                                        type: 'error'
                                    });
                                }
                            })
                        }
                    }
                });
            },
            reset2() {
                this.$refs['forms2'].resetFields();
            },
        }
    }
</script>

<style scoped>
.tab{margin-bottom: 20px; margin-left: 140px;}
.flexform{display: flex;flex-wrap: wrap;justify-content: space-between;}
.flexform .el-form-item{width: 48%;}
.flexform .noflex{ width: 100%;}
.flexform .noflex label{margin-right: 1%;}
.flexform .noflex .el-input{width: 15%; margin-right: 1%;}
</style>